import {
  FORGOT_PASSWORD_REQUEST,
  VERIFY_CODE_SUCCESS,
  RESET_PASSWORD_SUCCESS,
  GET_ERRORS,
  CLEAR_MESSAGES,
} from "../Actions/types";

const initialState = {
  email: "",
  codeVerified: false,
  passwordReset: false,
  error: null,
  success: null,
};

const forgetPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case FORGOT_PASSWORD_REQUEST:
    case VERIFY_CODE_SUCCESS:
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        success: action.payload, // Set the success message from the action
        error: null, // Clear any existing error
      };
    case GET_ERRORS:
      return {
        ...state,
        error: action.payload, // Set the error message from the action
        success: null, // Clear success on error
      };
    case CLEAR_MESSAGES: // Handle clearing messages
      return {
        ...state,
        error: null, // Clear error
        success: null, // Clear success
      };
    default:
      return state;
  }
};

export default forgetPasswordReducer;
